import { ITag } from 'services/api/entities';

export const normalizeTags = (tagsArray: ITag[]) => {
  const tags: { ids: string[]; entities: Record<string, ITag> } =
    tagsArray.reduce(
      (acc: { ids: string[]; entities: Record<string, ITag> }, tag: ITag) => {
        const newAcc = { ...acc };
        newAcc.ids.push(tag.id);
        newAcc.entities[tag.id] = tag;
        return newAcc;
      },
      { ids: [], entities: {} }
    );

  return tags;
};
